import * as React from 'react';

function SvgRoles(props) {
  return (
    <svg viewBox="0 0 52 48" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M43.956 19.5a5.997 5.997 0 01-5.994-6c0-3.314 2.683-6 5.994-6a5.997 5.997 0 015.994 6c0 3.314-2.684 6-5.994 6zM28.97 18c6.589 0 11.237 2.985 10.49 6l-4.496 18c-.285 3.015-3.874 6-7.493 6h-2.997c-3.786 0-7.353-2.985-7.492-6l-4.496-18c-.728-3.015 3.946-6 10.49-6zm4.495 12c.138-1.2.138-2.078 0-3-.96-.132-1.876-.132-2.997 0l-5.994 7.5-2.997-3c-1.12-.735-2.02-.735-2.997 0-.138.334-.138 1.197 0 1.5l4.496 4.5c.493.132 1.408.132 1.498 0zM18.481 7.5c0-4.142 3.355-7.5 7.493-7.5s7.492 3.358 7.492 7.5-3.354 7.5-7.492 7.5-7.493-3.358-7.493-7.5zm-10.49 12a5.996 5.996 0 01-5.993-6c0-3.314 2.684-6 5.994-6a5.997 5.997 0 015.994 6c0 3.314-2.684 6-5.994 6zM9.544 21c-.812 0-.444 2.576 0 5.757L12.54 42H8.044c-1.789 0-4.275-2.091-4.495-4.5l-2.997-12C.045 23.088 3.294 21 8.044 21h1.499zm32.914 0h1.499c4.75 0 7.999 2.088 7.492 4.5l-2.997 12c-.222 2.409-2.708 4.5-4.495 4.5H39.46l2.997-15.243c.442-3.181.812-5.757 0-5.757z"
        fill="#fcce01"
      />
    </svg>
  );
}

export default SvgRoles;
